import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import RequestModal from "../components/modal/AdvanceRequestDetails";
import PaginatedTable from "../components/library/Pagination";
import Loader from "../components/common/Loader";
import API_BASE_URL from "../config/api";

const AdvancePaymentRequests = () => {
    const [requests, setRequests] = useState([]);
    const [filteredRequests, setFilteredRequests] = useState([]);
    const [summary, setSummary] = useState({ total: 0, pending: 0, approved: 0 });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [SelectedReuestId, setSelectedReuestId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [generalMaster, setGeneralMaster] = useState([]);

    const token = sessionStorage.getItem("token");
    const employeeId = sessionStorage.getItem("employeeId");
    const role = sessionStorage.getItem("userrole");
    const [filters, setFilters] = useState({
        start: "",
        end: "",
        status: "",
        searchText: "",
    });

    useEffect(() => {
        fetchRequests();
    }, []);

    useEffect(() => {

        const fetchgeneralMaster = async () => {
            const res = await fetch(`${API_BASE_URL}/api/Config/AllGeneralMaster`, {

            });
            if (res.ok) {
                const data = await res.json();
                setGeneralMaster(data);
            }
        };
        fetchgeneralMaster();

    }, []);

    const fetchRequests = async (customFilters = filters) => {
        try {
            setLoading(true);

            if (!token) {
                console.error("No token found in sessionStorage");
                return;
            }

            const params = new URLSearchParams();

            if (customFilters.start?.trim()) params.append("start", customFilters.start);
            if (customFilters.end?.trim()) params.append("end", customFilters.end);
            if (customFilters.status) params.append("status", customFilters.status);
            if (customFilters.searchText?.trim()) params.append("searchText", customFilters.searchText);

            const query = params.toString();

            let url =
                role !== "1"
                    ? `${API_BASE_URL}/api/AdvancePayment/employee/${employeeId}`
                    : `${API_BASE_URL}/api/AdvancePayment/all${query ? `?${query}` : ""}`;

            const res = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` },
            });

            const apiData = Array.isArray(res.data) ? res.data : res.data.data || [];

            setRequests(apiData);
            setFilteredRequests(apiData);

            // summary calc
            const total = apiData.length;
            const pending = apiData.filter((x) => x.statusId === 75).length;
            const approved = apiData.filter((x) => x.statusId === 76 || x.statusId === 83).length;
            setSummary({ total, pending, approved });
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const openRequest = (reuestId) => {
        setSelectedReuestId(reuestId);
        setIsModalOpen(true);
    };


    const closeRequest = () => {
        setIsModalOpen(false);
        setSelectedReuestId(null);
        fetchRequests();
    };

    useEffect(() => {
        let result = [...requests];

        const text = filters.searchText?.toLowerCase() || "";
        if (text) {
            result = result.filter(
                (req) =>
                    req.employeeName?.toLowerCase().includes(text) ||
                    req.employeeCode?.toLowerCase().includes(text)
            );
        }

        if (filters.status) {
            result = result.filter(
                (req) => req.status?.toLowerCase() === filters.status.toLowerCase()
            );
        }

        if (filters.start) {
            const startDate = new Date(filters.start);
            result = result.filter((req) => new Date(req.requestDate) >= startDate);
        }

        if (filters.end) {
            const endDate = new Date(filters.end);
            result = result.filter((req) => new Date(req.requestDate) <= endDate);
        }

        setFilteredRequests(result);
    }, [filters, requests]); // only update filteredRequests, don't call fetchRequests



    const Filters = ({ filters, setFilters, onSearch, generalMaster }) => (

        <div className="px-4 py-3">
            <div className="flex flex-wrap items-center gap-4">

                <input
                    type="date"
                    name="start"
                    value={filters.start}
                    onChange={(e) => setFilters({ ...filters, start: e.target.value })}
                    className="form-input rounded-xl border h-14 p-3 w-40 sm:w-48 lg:w-56"
                    placeholder="Start Date"
                />

                <input
                    type="date"
                    name="end"
                    value={filters.end}
                    onChange={(e) => setFilters({ ...filters, end: e.target.value })}
                    className="form-input rounded-xl border h-14 p-3 w-40 sm:w-48 lg:w-56"
                    placeholder="End Date"
                />

                <select
                    name="status"
                    value={filters.status}
                    onChange={(e) => setFilters({ ...filters, status: e.target.value })}
                    className="form-input rounded-xl border h-14 p-3 w-44 sm:w-52 lg:w-60"
                >
                    <option value="">Select status</option>
                    {generalMaster
                        .filter((x) => x.mainId == 74)
                        .map((opt) => (
                            <option key={opt.id} value={opt.title}>
                                {opt.title}
                            </option>
                        ))}
                </select>
                <button
                    onClick={() => onSearch(filters)}
                    className="btn-black h-14 px-6"
                >
                    Search
                </button>
                <button
                    onClick={() => {
                        const clearedFilters = { start: "", end: "", status: "" };
                        setFilters(clearedFilters);
                        onSearch(clearedFilters);
                    }}
                    className="cancel-btn h-14 px-6"
                >
                    Clear
                </button>

            </div>
        </div>

    );

    return (
        <>
            {loading ? (
                <Loader message="Loading..." />
            ) : (
                <div className="relative flex min-h-screen flex-col bg-white group/design-root overflow-x-hidden">
                    <div className="layout-container flex h-full grow flex-col">
                        <div className="flex flex-1 justify-center py-5">
                            <div className="layout-content-container flex flex-col flex-1">
                                <div className="flex flex-wrap justify-between gap-3">
                                    <h1 className="text-3xl font-bold mb-6">Advance Payment Requests</h1>
                                    {role !== "1" && (
                                        <Link to="/app/advancepaymentrequest" className="p-4 ">
                                            <button className="custom-btn">
                                                <span className="truncate">+ New Request</span>
                                            </button>
                                        </Link>
                                    )}
                                </div>
                                {role === "1" && (
                                    <Filters
                                        filters={filters}
                                        setFilters={setFilters}
                                        onSearch={fetchRequests}
                                        generalMaster={generalMaster}
                                    />
                                )}
                                {/* Summary */}
                                <h3 className="text-[#121517] text-lg font-bold px-4 pb-2 pt-4">
                                    Summary
                                </h3>
                                <div className="flex flex-wrap gap-4 p-4">
                                    <div className="flex min-w-[158px] flex-1 flex-col gap-2 rounded-xl p-6 border border-[#dde1e4]">
                                        <p className="text-[#121517] text-base font-medium">Total Requests</p>
                                        <p className="text-[#121517] text-2xl font-bold">{summary.total}</p>
                                    </div>
                                    <div className="flex min-w-[158px] flex-1 flex-col gap-2 rounded-xl p-6 border border-[#dde1e4]">
                                        <p className="text-[#121517] text-base font-medium">Pending</p>
                                        <p className="text-[#121517] text-2xl font-bold">{summary.pending}</p>
                                    </div>
                                    <div className="flex min-w-[158px] flex-1 flex-col gap-2 rounded-xl p-6 border border-[#dde1e4]">
                                        <p className="text-[#121517] text-base font-medium">Approved</p>
                                        <p className="text-[#121517] text-2xl font-bold">
                                            {summary.approved}
                                        </p>
                                    </div>
                                </div>

                                <div className="flex justify-between w-full px-4">
                                    <h3 className="text-[#121517] text-lg font-bold px-4 pb-2 pt-4">
                                        Requests
                                    </h3>
                                    <div className="relative max-w-[250px] w-full">
                                        <span className="absolute inset-y-0 left-3 flex items-center text-gray-400">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-5 w-5"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth="2"
                                                    d="M21 21l-4.35-4.35M17 10a7 7 0 11-14 0 7 7 0 0114 0z"
                                                />
                                            </svg>
                                        </span>

                                        <input
                                            type="text"
                                            placeholder="Search by name"
                                            value={filters.searchText}
                                            onChange={(e) =>
                                                setFilters((prev) => ({ ...prev, searchText: e.target.value }))
                                            }
                                            className="rounded-md border h-14 pl-12 pr-3 w-full focus:ring-2 focus:ring-blue-400 outline-none"
                                        />
                                    </div>
                                </div>

                                {/* Table */}

                                <div className="px-4 py-3">
                                    <div className="flex overflow-hidden rounded-xl border border-[#dde1e3] bg-white">
                                        <PaginatedTable
                                            columns={[
                                                "Employee",
                                                "Request Date",
                                                "Amount",
                                                "Status",
                                                "Actions",
                                            ]}
                                            data={filteredRequests}
                                            pageSize={10}
                                            renderRow={(req, index) => (
                                                <tr key={req.id} className="border-t border-t-[#dde1e4]">
                                                    <td className="h-[72px] px-4 py-2 text-sm">
                                                        {req.employeeName}
                                                    </td>
                                                    <td className="h-[72px] px-4 py-2 text-sm text-[#677883]">
                                                        {new Date(req.requestDate).toLocaleDateString()}
                                                    </td>
                                                    <td className="h-[72px] px-4 py-2 text-sm text-[#677883]">
                                                        ₹{Number(req.amountRequested || 0).toLocaleString("en-US")}
                                                    </td>
                                                    <td className="h-[72px] px-4 py-2 text-sm">
                                                        <span
                                                            className={`rounded-lg px-4 py-1 text-sm font-medium
                                                  ${req.statusId === 76 ? "bg-green-100 text-green-700" : ""}
                                                  ${req.statusId === 84 ? "bg-red-100 text-red-700" : ""}
                                                  ${req.statusId === 75 ? "bg-yellow-100 text-yellow-700" : ""}
                                                  ${req.statusId === 83 ? "bg-green-100 text-green-700" : ""}
                                                `}
                                                        >
                                                            {req.status}
                                                        </span>
                                                    </td>
                                                    <td className="h-[72px] px-4 py-2 text-sm font-bold text-[#677883]">
                                                        <button
                                                            className="flex min-w-[80px] max-w-[80px] cursor-pointer items-center justify-center hover:bg-black hover:text-white overflow-hidden rounded-full h-8 px-4 bg-[#f1f3f4] text-[#121516] text-sm font-medium leading-normal w-full"
                                                            onClick={() => openRequest(req.id)}
                                                        >
                                                            View
                                                        </button>
                                                    </td>
                                                </tr>
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isModalOpen && SelectedReuestId && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-xl max-w-3xl w-full max-h-[90vh] overflow-auto relative">
                        <button
                            className="absolute top-2 right-4 text-gray-500 hover:text-gray-800"
                            onClick={closeRequest}
                        >
                            ✕
                        </button>
                        <RequestModal
                            requestId={SelectedReuestId}
                            onClose={() => closeRequest()}
                        />
                    </div>
                </div>
            )}
        </>
    );
};

export default AdvancePaymentRequests;